import { Saga, Task } from 'redux-saga';
import { delay, fork, takeLatest, cancel } from 'redux-saga/effects';
import { STOP_POLLING_TYPE } from './types';

const POLLING_DELAY = 3000;

export function* cancelPolling(pollTask: Task): Generator {
  yield cancel(pollTask);
}

export function* pollEndpointLoop(saga: Saga): Generator {
  while (true) {
    try {
      yield fork(saga);
      yield delay(POLLING_DELAY);
    } catch (e) {
      throw new Error(e as string);
    }
  }
}

export function* watchCancelPoll(pollTask: Task): Generator {
  yield takeLatest(STOP_POLLING_TYPE, () => cancelPolling(pollTask));
}

export function* pollOrCancelEndpoint(saga: Saga): Generator {
  const pollTask = yield fork(pollEndpointLoop, saga);
  yield watchCancelPoll(pollTask as Task);
}
